import React from 'react';
import Nav from './components/nav/Nav';
import Header from './components/header/Header';
import About from './components/about/About';
import Focus from './components/focus/Focus';
import Experience from './components/experience/Experience';
import Skills from './components/skills/Skills';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import FixedSocials from './components/fixed/FixedSocials';
import FixedEmail from './components/fixed/FixedEmail';
import useReveal from './hooks/useReveal';

const App = () => {
  useReveal();

  return (
    <>
      <Nav />
      <FixedSocials />
      <FixedEmail />

      <main>
        <Header />
        <About />
        <Focus />
        <Experience />
        <Skills />
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default App;
